import {
  ROUTE_HOME,
  ROUTE_LOADS,
  ROUTE_LOGIN,
  ROUTE_MEASURE,
  ROUTE_MEASURE_GRAIN,
  ROUTE_PARTIES,
  ROUTE_PARTIES_ADD,
  ROUTE_PARTIES_EDIT,
  ROUTE_PARTIES_GRAIN,
  ROUTE_PARTIES_GRAIN_ADD,
  ROUTE_PARTIES_GRAIN_EDIT,
  ROUTE_REPORTS,
  ROUTE_REPORTS_GRAIN,
} from '@/common/constants';
import { Auth } from '@/features/auth/components';
import { LoadWrapper } from '@/features/loads/components/LoadWrapper';
import { GeneralGrainWrapper } from '@/features/loads/components/general-grain';
import { GeneralWrapper } from '@/features/loads/components/general/GeneralWrapper';
import { SingleWrapper } from '@/features/loads/components/single';
import { PartiesGrainWrapper } from '@/features/parties-grain/component/list/PartiesGrainWrapper';
import { PartiesGrainAction } from '@/features/parties-grain/component/single/PartiesGrainAction';
import PartyWrapper from '@/features/parties/components/PartyWrapper';
import { PartiesAction } from '@/features/parties/components/party-actions/PartiesAction';
import { ReportsGrainWrapper } from '@/features/reports-grain/components';
import { ReportsWrapper } from '@/features/reports/components';
import { DefaultLayout } from '@/layouts';
import { AnalysisGrainPage } from '@/pages/analysis-grain';
import { LoadPage } from '@/pages/loads';
import { PartiesGrainPage } from '@/pages/parties-grain';
import Parties from '@/pages/parties/Parties';
import { ReportsPage } from '@/pages/reports';
import { ReportsGrainPage } from '@/pages/reports-grain';
import { Navigate, RouteObject } from 'react-router-dom';

const privateRoutes: RouteObject[] = [
  {
    path: ROUTE_LOADS,
    element: <LoadPage />,
    children: [
      { index: true, element: <Navigate to={`${ROUTE_LOADS}/ALL`} replace /> },
      {
        path: ':status',
        element: <LoadWrapper />,
        children: [{ path: ':id', element: <SingleWrapper /> }],
      },
      { path: 'analysis-grain/:id', element: <AnalysisGrainPage /> },
    ],
  },
  {
    path: ROUTE_MEASURE,
    element: <GeneralWrapper />,
    children: [{ path: ':id', element: <GeneralWrapper /> }],
  },
  {
    path: ROUTE_MEASURE_GRAIN,
    element: <GeneralGrainWrapper />,
    children: [{ path: ':id', element: <GeneralGrainWrapper /> }],
  },
  {
    path: ROUTE_PARTIES,
    element: <Parties />,
    children: [
      { index: true, element: <PartyWrapper /> },
      { path: ROUTE_PARTIES_ADD, element: <PartiesAction /> },
      { path: `${ROUTE_PARTIES_EDIT}/:id`, element: <PartiesAction /> },
    ],
  },
  {
    path: ROUTE_PARTIES_GRAIN,
    element: <PartiesGrainPage />,
    children: [
      {
        index: true,
        element: <PartiesGrainWrapper />,
      },
      { path: ROUTE_PARTIES_GRAIN_ADD, element: <PartiesGrainAction /> },
      {
        path: `${ROUTE_PARTIES_GRAIN_EDIT}/:id`,
        element: <PartiesGrainAction />,
      },
    ],
  },
  {
    path: ROUTE_REPORTS,
    element: <ReportsPage />,
    children: [{ index: true, element: <ReportsWrapper /> }],
  },
  {
    path: ROUTE_REPORTS_GRAIN,
    element: <ReportsGrainPage />,
    children: [{ index: true, element: <ReportsGrainWrapper /> }],
  },
];

export const routes = (): RouteObject[] => [
  {
    path: ROUTE_LOGIN,
    element: <Auth />,
  },
  {
    path: ROUTE_HOME,
    element: <DefaultLayout />,
    children: [
      { index: true, element: <Navigate to={ROUTE_LOADS} replace /> },
      ...privateRoutes,
    ],
  },
];
